import { useEffect, useRef, useState } from "react";
import { useInView, useMotionValue, useTransform, animate } from "framer-motion";

/**
 * Count-up number that starts animating when the element enters the viewport.
 * Accepts strings like "120+", "7 anos", "98%", "7 years" and animates only the numeric part.
 */
const CountUp = ({ value = "0", duration = 1.8, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  // Parse: prefix (usually empty), number, suffix
  const match = String(value).match(/^([^\d-]*)(-?\d+(?:[.,]\d+)?)(.*)$/);
  const prefix = match ? match[1] : "";
  const target = match ? Number(match[2].replace(",", ".")) : 0;
  const suffix = match ? match[3] : String(value);

  const mv = useMotionValue(0);
  const isFloat = String(target).includes(".");
  const rounded = useTransform(mv, (v) =>
    isFloat ? v.toFixed(1) : Math.round(v).toLocaleString("pt-PT")
  );
  const [text, setText] = useState(isFloat ? "0.0" : "0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(mv, target, {
      duration,
      ease: [0.22, 0.61, 0.36, 1],
    });
    const unsub = rounded.on("change", (v) => setText(v));
    return () => {
      controls.stop();
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, target, duration]);

  return (
    <span ref={ref} className={className}>
      {prefix}
      {text}
      {suffix}
    </span>
  );
};

export default CountUp;
